import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Radio } from 'rmwc/Radio';
import { IntRangeSelect } from '../../components/controls/IntRangeSelect';
import { Typography } from 'rmwc/Typography';
import { Text } from '../../components/Text';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const StyledAnswerRow = styled.div`
  width: 80%;
`;

class FamilySituation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasPartner: props.qna_hash.hasPartner ? props.qna_hash.hasPartner.answer : null,
      numberOfDependents: props.qna_hash.numberOfDependents ? props.qna_hash.numberOfDependents.answer : '0',
    };
  }

  componentDidMount() {
    this.props.pathAware('hasPartner');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.hasPartner) {
      this.setState({
        hasPartner: props.qna_hash.hasPartner.answer,
        numberOfDependents: props.qna_hash.numberOfDependents.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        hasPartner: {
          question: 'Are you Married?',
          answer: this.state.hasPartner,
        },
        numberOfDependents: {
          question: 'Do you have any children or dependents?',
          answer: this.state.numberOfDependents,
        },
      })
      .then(onContinue);
  };

  _canContinue = () => {
    return this.state.hasPartner !== null;
  };

  _onBack = () => {
    this.props.onBack();
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  render() {
    const { wrapper, qna_stack } = this.props;
    const { hasPartner } = this.state;

    return (
      <DynamicWrapper
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">Are you married?</Text>
        </div>
        <div className="mb-4">
          <Radio
            id="hasPartnerTrue"
            value="yes"
            checked={hasPartner === true}
            onChange={evt => this.setState({ hasPartner: true })}
          >
            <Typography use="subtitle1">Yes</Typography>
          </Radio>

          <span className="ml-4">
            <Radio
              id="hasPartnerFalse"
              value="no"
              checked={hasPartner === false}
              onChange={evt => this.setState({ hasPartner: false })}
            >
              <Typography use="subtitle1">No</Typography>
            </Radio>
          </span>
        </div>
        <div className="mt-3" style={{ width: '100%', borderTop: '1px solid #e0e0e0' }} />
        <Text className="mt-4 mb-0" use="headline6">
          Do you have any children or dependents?
        </Text>
        <StyledAnswerRow>
          <IntRangeSelect
            id="numberOfDependents"
            value={this.state.numberOfDependents}
            onChange={evt => this.onChange(evt, 'numberOfDependents')}
            label="Number of children or dependents"
            spec={{
              field_type: 'integer',
              min: 0,
              max: 10,
            }}
          />
        </StyledAnswerRow>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(FamilySituation);
